export default {
    introPopUp: {
        title:
      'Ήρθαν τα νέα ψηφιακά κουπόνια σου! Ανακάλυψέ τα και κέρδισε με τις αγορές σου.',
        description:
      'Για να τα εξαργυρώσεις θα πρέπει να πατήσεις πάλι το link από το κινητό σου όταν είσαι κοντά στο ταμείο. Στη συνέχεια να πατήσεις πάνω στα κουπόνια και στα επόμενα 60 λεπτά να δείξεις το barcode στο ταμείο μαζί με τις αγορές σου.',
        button: 'ΔΕΣ ΤΑ ΚΟΥΠΟΝΙΑ ΣΟΥ'
    },
    couponsList: {
        validUntil: 'Ισχύουν έως ',
        description:
      'Όταν είσαι στο ταμείο πάτησε πάνω στην εικόνα του κάθε κουπονιού για να το εξαργυρώσεις',
        termsHeader: 'Οδηγίες εξαργύρωσης',
        terms: [
            '  1. Αφού πατήσεις πάνω στο κουπόνι θα εμφανιστεί το barcode που θα δείξεις στο ταμείο για εξαργύρωση.',
            '  2. Έχεις 60 λεπτά για να το εξαργυρώσεις. Στη συνέχεια το κουπόνι απενεργοποιείται.',
            '   3. Θα λάβεις το όφελος με την αγορά προϊόντος που αναγράφεται στο κουπόνι με τη χρήση της ClubCard ΚΡΗΤΙΚΟΣ.',
            '   4. Κάθε κουπόνι ισχύει μία φορά και σε μία συναλλαγή σου σε κατάστημα ΚΡΗΤΙΚΟΣ.'
        ],
        uniterms: [
            '  1. Αφού πατήσεις πάνω στο κουπόνι θα εμφανιστεί το barcode που θα δείξεις στο ταμείο για εξαργύρωση.',
            '  2. Έχεις 60 λεπτά για να το εξαργυρώσεις. Στη συνέχεια το κουπόνι απενεργοποιείται.',
            '  3. Ολοκληρώνοντας τις αγορές σου στο ταμείο θα λάβεις την έκπτωση.',
            '   4. Κάθε κουπόνι ισχύει μία φορά και σε μία συναλλαγή σου σε κατάστημα ΚΡΗΤΙΚΟΣ.'
        ],
        expired: 'ΑΝΕΝΕΡΓΟ',
        redeemed: 'ΕΝΕΡΓΟΠΟΙΗΜΕΝΟ'
    },
    activationPopUp: {
        title: 'Είσαι κοντά στο ταμείo;',
        description:
      'Αφού ενεργοποιήσεις το κουπόνι θα παραμείνει διαθέσιμο προς εξαργύρωση για τα επόμενα 60 λεπτά και μετά θα απενεργοποιηθεί. Κάθε προσφορά ισχύει μία φορά.',
        confirmButton: 'ΕΝΕΡΓΟΠΟΙΗΣΗ',
        cancelButton: 'ΟΧΙ ΑΚΟΜΑ'
    },
    coupon: {
        duration: 'Το κουπόνι λήγει σε:',
        description:
      'Κουπόνι για εξαργύρωση στα ταμεία των καταστημάτων. Ισχύει για μία φορά, σε μία συναλλαγή.',
        expired: 'Το κουπόνι έχει λήξει'
    },
    error: {
        errorText: {
            default: 'Ουπς κάτι πήγε στραβά',
            inactiveOffer: 'Τα κουπόνια έχουν λήξει'
        },
        errorDescription: {
            default:
        'Επιβεβαίωσε ότι είσαι συνδεδεμένος στο Internet. Αν είσαι και το πρόβλημα επιμένει παρακαλώ δοκίμασε αργότερα.',
            inactiveOffer: 'Η συγκεκριμένη ενέργεια κουπονιών έχει ολοκληρωθεί.'
        }
    }
}
